// extracted by mini-css-extract-plugin
module.exports = {"root":"Categories_root__fFIKx","titleContainer":"Categories_titleContainer__2yeMW","spinnerWrapper":"Categories_spinnerWrapper__3gKCv"};